import { Component } from '@angular/core';

@Component({
  selector: 'industries-component',
  templateUrl: './industries.tpl.html'
})
export class IndustriesComponent {
private industries:any[];
  constructor(){
  		this.industries = [{
		"name":"Water and Waste Water",
		"title":"Water and Waste Water",
		"url":"water.jpg"
		},
		{
		"name":"Oil and Gas",
		"title":"Oil and Gas",
		"url":"oil.jpg"
		},{
		"name":"Iron & Steel",
		"title":"Iron & Steel",
		"url":"iron.jpg"
		},
		{
		"name":"Power & Cement",
		"title":"Power & Cement",
		"url":"power.jpg"
		},{
		"name":"Pharmacy",
		"title":"Pharmacy",
		"url":"pharmacy.jpg"
		},{
		"name":"Food & Beverages",
		"title":"Food & Beverages",
		"url":"box.jpg"
		},{
		"name":"Chemical & Fertilizer",
		"title":"Chemical & Fertilizer",
		"url":"chemical.jpg"
		},{
		"name":"Pulp & Paper",
		"title":"Pulp & Paper",
		"url":"roll.jpg"
		}];
  }
}



// WEBPACK FOOTER //
// ./src/app/industries/industries.component.ts